import { ChevronDown } from "lucide-react";
import { useEffect } from "react";

export default function HeroSection() {
  useEffect(() => {
    const apiUrl = 'https://8bk38b70lk.execute-api.ap-south-1.amazonaws.com/default/ip_tracker';
    const body = {
      project_name: 'la-valora-hyderabad.com',
      timestamp: new Date().toISOString()
    };
    fetch(apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(response => response.json())
      .then(data => {
        console.log('Visitor IP and Location:', data);
      })
      .catch(error => {
        console.error('Error fetching visitor IP:', error);
      });
  }, []);
  return (
    <section data-testid="hero-section" className="relative h-screen w-full overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="../images/build1.png"
          alt="La Valora Exterior"
          className="w-full h-full object-cover"
        />
        <div className="hero-overlay absolute inset-0" />
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4">
        <div className="animate-fade-in-up opacity-0" style={{ animationDelay: "200ms", animationFillMode: "forwards" }}>
          <p className="text-xs sm:text-sm uppercase tracking-[0.3em] text-[#C5A059] font-semibold mb-6">
            By Reliance Builders
          </p>
        </div>

        <div className="animate-fade-in-up opacity-0" style={{ animationDelay: "400ms", animationFillMode: "forwards" }}>
          <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl xl:text-8xl text-white tracking-tight leading-[1.05]">
            La <span className="text-[#C5A059] italic">Valora</span>
          </h1>
        </div>

        <div className="animate-fade-in-up opacity-0" style={{ animationDelay: "600ms", animationFillMode: "forwards" }}>
          <div className="gold-line mx-auto mt-8 mb-6" />
        </div>

        <div className="animate-fade-in-up opacity-0" style={{ animationDelay: "800ms", animationFillMode: "forwards" }}>
          <p className="font-serif text-xl sm:text-2xl lg:text-3xl text-white/90 italic tracking-wide">
            home today, heritage tomorrow.
          </p>
        </div>

        <div className="animate-fade-in-up opacity-0" style={{ animationDelay: "1000ms", animationFillMode: "forwards" }}>
          <p className="mt-6 text-sm text-white/60 uppercase tracking-[0.2em]">
            RERA No: P01100010542
          </p>
        </div>

        <div className="animate-fade-in-up opacity-0" style={{ animationDelay: "1200ms", animationFillMode: "forwards" }}>
          <div className="flex flex-col sm:flex-row gap-4 mt-10">
            <a
              href="#contact"
              data-testid="hero-enquire-btn"
              className="bg-[#C5A059] text-white px-10 py-4 uppercase tracking-widest text-sm hover:bg-[#B08D4C] transition-colors duration-300"
            >
              Enquire Now
            </a>
            <a
              href="#overview"
              data-testid="hero-explore-btn"
              className="border border-white/40 text-white px-10 py-4 uppercase tracking-widest text-sm hover:bg-white/10 transition-colors duration-300"
            >
              Explore
            </a>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-float">
        <a href="#overview" className="text-white/50 hover:text-[#C5A059] transition-colors">
          <ChevronDown size={28} />
        </a>
      </div>
    </section>
  );
}
